import { type RouterOptions } from "vue-router";

// Troubleshoot your routes using this - https://paths.esm.dev

const names = {
  incidentDataDownload: "Analytics.AnalyticsIncidentDataDownload",
  bcStatesExport: "Analytics.AnalyticsBcStatesExport",
  releaseNotificationLog: "Analytics.AnalyticsReleaseNotificationLog",
  releaseNotificationLogWithQuantity: "Analytics.AnalyticsReleaseNotificationLogWithQuantity",
};

export { names as analyticsRouteNames };

const quickBooksRoutes: RouterOptions["routes"] = [
  {
    path: "/analytics",
    component: () => import("@/views/analytics/AnalyticsBase.vue"),
    children: [
      {
        path: "downloadIncidentData",
        name: names.incidentDataDownload,
        meta: { title: "Incident Data Download", hideFilterChange: true },
        component: () => import("@/views/analytics/AnalyticsIncidentDataDownload.vue"),
      },
      {
        path: "bcStatesExport",
        name: names.bcStatesExport,
        meta: { title: "BC/States Export", hideFilterChange: true },
        component: () => import("@/views/analytics/AnalyticsBcStatesExport.vue"),
      },
      {
        path: "releaseNotificationLog",
        name: names.releaseNotificationLog,
        meta: { title: "Release Notification Log", hideFilterChange: true },
        component: () => import("@/views/analytics/AnalyticsReleaseNotificationLogExport.vue"),
      },
      {
        path: "releaseNotificationLogWithQuantity",
        name: names.releaseNotificationLogWithQuantity,
        meta: { title: "Release Notification Log with Quantity", hideFilterChange: true },
        component: () => import("@/views/analytics/AnalyticsReleaseNotificationLogWithQuantityExport.vue"),
      },
    ],
  },
];
export default quickBooksRoutes;
